_ = require('lodash')

class RoundBasicChartCtrl
  constructor: (@$scope) ->
    @basicAnalysisData =
      goal: @$scope.$parent.goalSettings
      all_members: @$scope.$parent.allMembers
      my_avg: _.merge {}, @$scope.$parent.playersAnalysis.players[0],
        avg_total_shot: @$scope.$parent.playersAnalysis.players[0].total_shot
      showRoundIcon: true

RoundBasicChartCtrl.$inject = [
  '$scope'
]

module.exports = RoundBasicChartCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/round-basic-chart/round-basic-chart-controller.coffee